export const isBrowser = typeof globalThis.window !== "undefined";
